import { Navigate, Outlet } from 'react-router-dom';
import { COMPANY_USER_ROLE, useAuthUserCompany } from '@durma-soft/gros-sdk';

export const UserIsCompanyAdministratorMiddleware = () => {
  const { role } = useAuthUserCompany();

  if (role === COMPANY_USER_ROLE.TRACK_EMPLOYEE) {
    return (
      <>
        <Navigate to="/company/track" />
        <Outlet />
      </>
    );
  }

  return (
    <>
      <Outlet />
    </>
  );
};
